import React, { useEffect, useState } from "react";
import "./Subscribe.css";
import subsImg from "./../../Images/subs-img.png";
import Swal from "sweetalert2";
import CircularLoader from "./../../CircularLoader/CircularLoader.js";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import WhatsappIcon from "./../../Images/whatsapp.png";
import EnquirePopup from "../EnquirePopup.jsx";

const apiUrl = process.env.REACT_APP_BACKEND_URL;

const Subscribe = () => {
  const navigate = useNavigate(null);
  const [email, setEmail] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [errorEmail, setErrorEmail] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [message, setMessage] = useState("");
  function isValidEmail(email) {
    // Define the regular expression pattern for a valid email address
    var pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // Use the test method to check if the email matches the pattern
    var isValid = pattern.test(email);

    // If isValid is true, the email is valid; otherwise, it's not
    return isValid;
  }

  const [countryCode, setCountryCode] = useState("in");

  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const res = await fetch("https://ipapi.co/json");
        const data = await res.json();
        setCountryCode(data?.country_code?.toLowerCase() || "in");
      } catch (err) {
        console.log("Could not fetch country. Defaulting to IN");
      }
    };
    fetchCountry();
  }, []);

  const handlePopup = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };
  const handleSubmit = () => {
    if (!isValidEmail(email)) {
      setErrorEmail(true);
      toast.error("Enter Valid Email", {
        position: toast.POSITION?.TOP_RIGHT,
        autoClose: 2000,
      });
    } else {
      setIsSubmit(true);
      let data = {
        email: email,
        textareaValue: message,
      };
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${apiUrl}api/v1/info/saveContactInfo`,
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          setEmail("");
          setMessage("");
          setIsSubmit(false);
          // Swal.fire("Success", "Thank you for contacting us!", "We have received your message. We will reach you out immediately!");
          Swal.fire({
            icon: "success",
            title: "Thank you for contacting us!",
            text: "We have received your message. We will reach you out immediately!",
            // icon: "question"
          });
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message || "Something went wrong", {
            position: toast.POSITION?.TOP_RIGHT,
            autoClose: 2000,
          });
          Swal.fire(
            "error",
            err?.response?.data?.message || "Something went wrong!",
            "error"
          );
          setIsSubmit(false);
        });
    }
  };
  return (
    <>
      <div className="container-fluid black">
        <div className="container subscribe-main">
          <h2>
            Limited Time Offer: Get your NFC Business Card for only INR
            499/year!
          </h2>
          {/* <h5>
            Just share your details and our team will get back to you shortly.
          </h5> */}
          {/* <div className="subscribe" style={{display:"flex"}}>
            <img src={subsImg} />
            <input
              onChange={(e) => {
                setEmail(e.target.value);
                setErrorEmail(false);
              }}
              value={email}
              type="text"
              placeholder="Your email address"
            />
         
          </div>
        <div className="mailerrormsg">
        {errorEmail && (
              <span style={{color:"red"}} className="error-message">Enter a valid email</span>
            )}
        </div> */}
          {/* <div className="subscribe">
            <input
              onChange={(e) => setMessage(e.target.value)}
              type="textarea"
              value={message}
              placeholder="Message"
            />
          </div> */}
          <a
            style={{ cursor: "pointer" }}
            onClick={handlePopup}
            className="green-button"
          >
            {/* <img src={WhatsappIcon} style={{width:"36px", height:"36px"}}/> */}
            Get started now
          </a>
          {/* <button
            style={{ cursor: "pointer" , marginTop:"5px" }}
            onClick={handleSubmit}
            className="blue-button-subscribe"
          >
            {isSubmit ? <CircularLoader size={20} /> : `Contact Us`}
          </button> */}
          {/* <h4>
            After clicking “Get started” button you agree with our{" "}
            <span
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/term-conditions")}
              className="blue-text"
            >
              Terms and Conditions.
            </span>
          </h4> */}
        </div>
        {showPopup && (
          <EnquirePopup
            open={showPopup}
            onClose={closePopup}
            setOpen={setShowPopup}
          />
        )}
        <p style={{margin:"0px", padding:"10px 0"}}>© 2025, BusinessBay. All rights reserved.</p>

        {countryCode && countryCode == "in" ? (
          <a
            href="https://api.whatsapp.com/send/?phone=917835014801&text=NFC%20Cards&type=phone_number&app_absent=0"
            //  class="Footer_whatsappFloat"
            style={{
              position: "fixed",
              bottom: "20px",
              right: "20px",
              backgroundColor: "#25d366",
              color: "white",
              borderRadius: "50%",
              padding: "12px",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
              zIndex: 99999999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "transform 0.2s ease, background-color 0.2s ease",
              textDecoration: "none",
            }}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat with us on WhatsApp"
          >
            <svg
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 448 512"
              height="28"
              width="28"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"></path>
            </svg>
          </a>
        ) : (
          <a
            href="https://wa.me/971562198924"
            //  class="Footer_whatsappFloat"
            style={{
              position: "fixed",
              bottom: "20px",
              right: "20px",
              backgroundColor: "#28b73e",
              color: "white",
              borderRadius: "50%",
              padding: "12px",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
              zIndex: 99999999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "transform 0.2s ease, background-color 0.2s ease",
              textDecoration: "none", // optional
            }}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat with us on WhatsApp"
          >
            <svg
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 448 512"
              height="28"
              width="28"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"></path>
            </svg>
          </a>
        )}
      </div>
    </>
  );
};

export default Subscribe;
